<template>
  <div>
    <div v-if="!haveMessages">
      <p>{{ $t("messages.not-messages") }}</p>
    </div>
    <div class="columns is-multiline">
      <template v-for="message in messages">
        <Message :message="message" :key="message.id" />
      </template>
    </div>
  </div>
</template>

<script>
import Message from "./Message.vue";
import moment from "moment";
import { RepositoryFactory } from "@/services/api";

export default {
  name: "messages",
  components: {
    Message,
  },
  props: {
    roomId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
    };
  },
  mounted() {
    this.retrieveMessages();
  },
  computed: {
    haveMessages() {
      return this.messages.length > 0;
    },
  },
  methods: {
    async retrieveMessages() {
      let response = await RepositoryFactory.conference.getMessages({
        roomId: this.roomId,
      });
      let messages = response.data;

      messages.map(function (m) {
        m.date = moment(m.sendDate).locale("es").format("hh:mm:ss");
        return m;
      });

      this.messages = messages;
    },
  },
};
</script>